import { siteNames } from '@seek/melways-sites';

import { navigateToUrl } from 'src/components/app/JobSection/utils';
import {
  FACEBOOK_SOCIAL_SHARE,
  TWITTER_SOCIAL_SHARE,
  LINKEDIN_SOCIAL_SHARE,
  FACEBOOK,
  TWITTER,
  LINKEDIN,
  COPY,
} from 'src/constants/socialShare';
import type { EmployerSiteNames } from 'src/siteConfig';

import canCopyViaApiAsync from './canCopyViaApiAsync';
import { logUnificationTbdWarnings } from './logUnificationTbdWarnings';

const copyToClipboard = (stringToCopy: string) => {
  try {
    canCopyViaApiAsync().then((result) => {
      if (result) {
        navigator.clipboard.writeText(stringToCopy);
      } else {
        const textArea = document.createElement(
          'textArea',
        ) as HTMLTextAreaElement;
        textArea.value = stringToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand?.('copy');
        document.body.removeChild(textArea);
      }
    });
  } catch (error) {}
};

const getSiteForTwitterShareUrl = (site: EmployerSiteNames) => {
  switch (site) {
    case siteNames.employer.seek.au:
      return 'seekjobs';
    case siteNames.employer.seek.nz:
      return 'seekjobsnz';
    case siteNames.employer.seek.th:
    case siteNames.employer.seek.hk:
    case siteNames.employer.seek.id:
    case siteNames.employer.seek.my:
    case siteNames.employer.seek.ph:
    case siteNames.employer.seek.sg:
    default:
      logUnificationTbdWarnings({
        site,
        title: 'Twitter share link',
        desc: 'Twitter user not supported for site',
        action: `Returning 'seekjobs' twitter user instead`,
      });
      return 'seekjobs';
  }
};

const handleClickSocialShareLink = ({
  option,
  jobAdUrl,
  title,
  site,
}: {
  option: string;
  jobAdUrl: string;
  title: string;
  site: EmployerSiteNames;
}) => {
  let url;
  switch (option) {
    case FACEBOOK:
      url = `${FACEBOOK_SOCIAL_SHARE}${encodeURIComponent(
        jobAdUrl,
      )}&t=We+are+recruiting+for+the+below+role`;
      navigateToUrl(url, true);
      return;
    case TWITTER:
      url = `${TWITTER_SOCIAL_SHARE}${encodeURIComponent(
        jobAdUrl,
      )}&text=We+are+recruiting+for+a+${encodeURIComponent(
        title,
      )}&via=${getSiteForTwitterShareUrl(site)}`;
      navigateToUrl(url, true);
      return;
    case LINKEDIN:
      url = `${LINKEDIN_SOCIAL_SHARE}${encodeURIComponent(jobAdUrl)}`;
      navigateToUrl(url, true);
      return;
    case COPY:
      copyToClipboard(jobAdUrl);
      return;
    default:
      throw new Error('Unknown social share click');
  }
};

export default handleClickSocialShareLink;
